import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './component/login.component';
import {LoginRoutingModule} from "./routing.module";
import {ReactiveFormsModule} from "@angular/forms";
import {MessagesModule} from "primeng/components/messages/messages";
import {InputTextModule} from "primeng/components/inputtext/inputtext";
import {ValidationMessagesModule} from "../core/validation-messages/validation-messages.module";
import {RegisterFormComponent} from './register-form/register-form.component';
import {DropdownModule} from "primeng/primeng";

@NgModule({
    imports: [
        InputTextModule,
        MessagesModule,
        CommonModule,
        ReactiveFormsModule,
        ValidationMessagesModule,
        LoginRoutingModule,
        DropdownModule
    ],
    declarations: [LoginComponent, RegisterFormComponent]
})
export class LoginModule {
}



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts